// Kanonische Plattform-Domain (Session A, Legal-Routen).
//
// Beim Domain-Umzug scrolly.online → scrolly.com ist NUR diese Konstante
// zu ändern — alle Legal-Links in Footer/Sidebar hängen hieran.
//
// Bewusst NICHT verwendet von den älteren Hardcodes in usePublicAuth,
// OidcAuthProvider und allowed-return-domains (Auth-Flow-Refactor ist
// nicht Session-A-Scope; siehe Briefing Scope-Ergänzung b).
// env-gesteuert (2026-07-14): auf .com muss der Footer/Legal-Links auf die
// .com-Plattform zeigen, nicht auf den hart codierten .online-Default. Der
// Viewer-Build setzt VITE_PORTAL_BASE_URL pro Umgebung (dev=dev-portal.scrolly.com,
// prod=scrolly.com). Default bleibt .online → bricht die .online-Linie NICHT.
export const PLATFORM_BASE_URL =
  import.meta.env.VITE_PORTAL_BASE_URL || "https://platform.scrolly.online";

export const LEGAL_URLS = {
  imprint: `${PLATFORM_BASE_URL}/imprint`,
  privacy: `${PLATFORM_BASE_URL}/privacy`,
  terms: `${PLATFORM_BASE_URL}/terms`,
} as const;
